
import { defineComponent } from 'vue';
import ESARSite from '@/models/ESARSite';

import CircleImage from '../CircleImage/CircleImage.vue';

export default defineComponent({
    name: 'RemediationSystem',
    components: {
        CircleImage
    },
    props: {
        siteDetails: ESARSite
    },
    setup(props) {
        const data1 = [
            { title: 'landfarming', state: props.siteDetails?.landFarming },
            { title: 'Soil vapour extraction', state: props.siteDetails?.soilVaporExtraction },

        ];
        const data2 = [
            { title: 'Air sparging', state: props.siteDetails?.airSparging },
            { title: 'Allu bucket', state: props.siteDetails?.alluBucket },
            { title: 'Biopiles', state: props.siteDetails?.bioPiles },
            { title: 'Biosparging', state: props.siteDetails?.bioSparging },
            { title: 'Bioventing', state: props.siteDetails?.bioventing },
            { title: 'Chemical oxidation', state: props.siteDetails?.chemicalOxidation },
            { title: 'Dig and dump', state: props.siteDetails?.digAndDump },
            { title: 'Dual phase extraction', state: props.siteDetails?.dualPhaseExtraction },
            { title: 'Enhanced aerobic bioremediation', state: props.siteDetails?.enhancedAerobicBioRemediation },
            { title: 'In situ groundwater bioremediation', state: props.siteDetails?.inSituGroundwaterBioRemediation },
            { title: 'Low temp thermal desorption', state: props.siteDetails?.lowTempThermalDesorption },
            { title: 'Other', state: props.siteDetails?.other },
        ];

        return {
            data1,
            data2
        };
    }
});
